<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" @change="yearChangeForGraph1" unit="건" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateRangeChangeForGraph3">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       class="py-3 px-0 lg:px-8" type="border" @click="dataTypeChangeForGraph3(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
export default {
  name: "GraphDetail312",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getFieldLabel() {
      return '사업장';
    },
    getButtons() {
      return this.buttons;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  data() {
    return {
      buttons: [
        { label: '부서(과)', dataType: 'company' },
        { label: '사업장', dataType: 'field' },
        { label: '재해형태', dataType: 'disaster' },
      ],
      graph1: {
        title: "전체 산업재해 발생 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 산업재해 발생 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "건" }, { name: "전월대비 증감" }],
        list: [],
        dataType: this.$route.params.proj_id ? "company" : "project",
      },
      graph3: {
        title: "기간별 산업재해 발생 현황",
        label: '',
        unit: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        list: [],
        dataType: this.$route.params.proj_id ? "company" : "project",
      },
      cache: {},
      loading: false,
    };
  },
  async mounted() {
    if (!this.$store.state.member.memberInfo.projects) {
      await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    }

    // 데이터 로드를 먼저 수행하여 캐시에 저장합니다.
    await this.loadGraph1();
    // loadGraph3는 loadGraph1 이후 호출되므로 캐시를 사용하게 됩니다.
    await this.loadGraph3();

    // 초기 dataType 설정 및 관련 그래프 업데이트
    // dataTypeChangeForGraph2 내부에서 loadGraph2가 호출되며,
    // loadGraph1에서 이미 데이터를 캐싱했으므로 API 호출 없이 캐시를 사용합니다.
    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;
    this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);

    // 아래 두 줄은 dataTypeChangeForGraph2 호출로 인해 중복되거나 필요 없으므로 주석 처리하거나 삭제할 수 있습니다.
    // await this.loadGraph2();
  },
  methods: {
    async loadDetailData(targetYear) {
      // 년도가 없으면 현재 년도로 설정
      if (!targetYear) {
        targetYear = new Date().getFullYear();
      }

      const fromDate = `${targetYear}-01-01`;
      const toDate = `${targetYear}-12-31`;
      const cacheKey = `detail_312_${targetYear}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }


      // 전체 사업장 메타 정보를 조회한다
      // 메타에 저장된 "과" 정보를 불러오기 위해
      const metaResponse = await this.$store.dispatch('project/LOAD_FIELD_META', {
        perPage: 10000,
        metaKeys: ['com_name']
      });
      const fieldMetas = metaResponse.data || [];
      const comNameByFieldId = {};
      const fieldNameByFieldId = {};
      for (const fieldMeta of fieldMetas) {
        let comName = '기타';
        if (fieldMeta.metas && fieldMeta.metas.com_name) {
          comName = fieldMeta.metas.com_name;
        }
        comNameByFieldId[fieldMeta.id] = comName;
        fieldNameByFieldId[fieldMeta.id] = fieldMeta.field_name;
      }


      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      const conditions = [
        { key: 'body.stdInfo.date', operator: '>=', value: fromDate },
        { key: 'body.stdInfo.date', operator: '<=', value: toDate },
      ];

      const params = {
        projectId: this.projectId,
        boardId: 117,
        page: 1,
        perPage: 10000,
        conditions,
        withMeta: true,
        metaKeys: [
          'body.inputD_5', // 재해형태
          'body.stdInfo.date' // 일자
        ],
        onlyMeta: true,
        withoutRelation: true,
        forDashboard: true,
      };

      const response = await this.$store.dispatch('board/LOAD_POST_LIST', params);
      const postList = response.data || [];

      // 13개의 배열을 생성 (0: 년도 합산, 1-12: 월별 데이터)
      const data = {
        과: Array(13).fill().map(() => []),
        재해형태: Array(13).fill().map(() => []),
        사업장: Array(13).fill().map(() => [])
      };

      for (const post of postList) {
        const body = post.postContents.body;
        if (!body) {
          continue;
        }

        const fieldId = post.field_id;
        const 과이름 = comNameByFieldId[fieldId] || '기타';
        const 재해형태 = body.inputD_5 || '기타';
        const 사업장이름 = fieldNameByFieldId[fieldId] || '기타';
        const 일자 = new Date(body.stdInfo.date);
        const 월 = 일자.getMonth() + 1;

        // 과 데이터 처리
        this.updateMonthlyData(data.과, 과이름, 1, 월);

        // 교육구분 데이터 처리
        this.updateMonthlyData(data.재해형태, 재해형태, 1, 월);

        // 사업장 데이터 처리
        this.updateMonthlyData(data.사업장, 사업장이름, 1, 월);
      }

      // 각 카테고리별로 모든 배열(년도 합산 포함)을 count 기준 내림차순 정렬
      Object.keys(data).forEach(category => {
        data[category].forEach(monthData => {
          monthData.sort((a, b) => b.count - a.count);
        });
      });

      this.cache[cacheKey] = data;
      return data;
    },

    updateMonthlyData(dataArray, label, count, month) {
      // 년도 합산 데이터 처리 (0번째 배열)
      const foundYear = dataArray[0].find(row => row.label === label);
      if (foundYear) {
        foundYear.count += count;
      } else {
        dataArray[0].push({ label, count });
      }

      // 월별 데이터 처리 (1-12번째 배열)
      const foundMonth = dataArray[month].find(row => row.label === label);
      if (foundMonth) {
        foundMonth.count += count;
      } else {
        dataArray[month].push({ label, count });
      }
    },

    /**
     * 그래프 1
     * 월별 이수자 수를 표시한다.
     */
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const currentYearData = await this.loadDetailData(yyyy);
      const prevYearData = await this.loadDetailData(yyyy - 1);

      const currentYearMonthlyData = Array(12).fill().map(() => 0);
      const prevYearMonthlyData = Array(12).fill().map(() => 0);

      // 현재 연도 월별 데이터 처리 (1-12번째 배열)
      for (let i = 1; i <= 12; i++) {
        currentYearMonthlyData[i - 1] = currentYearData.과[i].reduce((sum, item) => sum + item.count, 0);
      }

      // 이전 연도 월별 데이터 처리 (1-12번째 배열)
      for (let i = 1; i <= 12; i++) {
        prevYearMonthlyData[i - 1] = prevYearData.과[i].reduce((sum, item) => sum + item.count, 0);
      }

      this.graph1.data1 = currentYearMonthlyData;
      this.graph1.data2 = prevYearMonthlyData;
      this.graph1.sum1 = currentYearData.과[0].reduce((sum, item) => sum + item.count, 0);
      this.graph1.sum2 = prevYearData.과[0].reduce((sum, item) => sum + item.count, 0);
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      const data = await this.loadDetailData(yyyy);

      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "company":
        graph2Data = data.과;
        break;
      case "field":
        graph2Data = data.사업장;
        break;
      case "disaster":
        graph2Data = data.재해형태;
        break;
      default:
        return;
      }

      const currentMonth = this.graph2.month;
      const currentData = graph2Data[currentMonth];
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;
      const prevData = graph2Data[prevMonth];

      const list = [];
      let no = 1;

      // 현재 월 데이터 처리
      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          name: row.label,
          value: new Intl.NumberFormat().format(row.count),
          valueRaw: row.count,
          gap,
        });
        no += 1;
      }

      // 이전 월 데이터 중 현재 월에 없는 항목 처리
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            name: row.label,
            value: "0",
            valueRaw: 0,
            gap: -row.count,
          });
          no += 1;
        }
      }

      // list를 valueRaw 기준으로 내림차순 정렬
      list.sort((a, b) => b.valueRaw - a.valueRaw);

      this.graph2.list = list;
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
      }
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = label;
      if (this.projectId) {
        this.graph2.dataType = dataType;
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      const data = await this.loadDetailData(yyyy);

      let graph3Data = [];

      switch (this.graph3.dataType) {
      case "company":
        graph3Data = data.과;
        break;
      case "field":
        graph3Data = data.사업장;
        break;
      case "disaster":
        graph3Data = data.재해형태;
        break;
      default:
        return;
      }

      const currentMonth = this.graph3.month;
      const currentData = graph3Data[currentMonth];

      const list = currentData.map(row => ({
        label: row.label,
        value: row.count
      }));

      this.graph3.list = list;
    },
    dateRangeChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      // this.graph3.beginDate = beginDate;
      // this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType, label) {
      this.graph3.label = label
      if (this.projectId) {
        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },
  },
};
</script>

<style scoped></style>
